module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example1_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-left"
  }, [(_vm.brandBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brand_query),
      callback: function($$v) {
        _vm.brand_query = $$v
      },
      expression: "brand_query"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.brand_query.value !== 0 && _vm.brand_query.value !== '0' && _vm.storeBriefQ.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBriefQ,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.store_query),
      callback: function($$v) {
        _vm.store_query = $$v
      },
      expression: "store_query"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            項目名稱\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name_query),
      expression: "name_query"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.name_query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name_query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            追蹤碼\n          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code_query),
      expression: "code_query"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "僅大小寫英文和數字",
      "type": "text",
      "maxlength": "25"
    },
    domProps: {
      "value": (_vm.code_query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code_query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n            入口\n          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sourceSelect),
      expression: "sourceSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sourceSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sourceList), function(source) {
    return _c('option', {
      domProps: {
        "value": source.value
      }
    }, [_vm._v("\n            " + _vm._s(source.label) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.click_add
    }
  }, [_vm._v("+新增")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.brandBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.brandBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 品牌 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.brandSelect),
      callback: function($$v) {
        _vm.brandSelect = $$v
      },
      expression: "brandSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.storeBrief.length > 2 && _vm.$route.name !== 'storeInfo') ? _c('div', {
    staticClass: "form-group"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.storeBrief,
      "searchable": true,
      "allow-empty": false,
      "close-on-select": true,
      "placeholder": "== 門市 ==",
      "show-labels": false,
      "multiple": false,
      "label": "label",
      "track-by": "value"
    },
    model: {
      value: (_vm.storeSelect),
      callback: function($$v) {
        _vm.storeSelect = $$v
      },
      expression: "storeSelect"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.isLoading) ? _c('tbody', [_vm._m(3)]) : (_vm.orderList.length === 0) ? _c('tbody', [_vm._m(4)]) : (_vm.orderList.length > 0) ? _c('tbody', _vm._l((_vm.orderList), function(order, index) {
    return _c('tr', {
      staticClass: "even",
      class: {
        'bg-pre-order': order.order_method === 2
      },
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(_vm.getTime(order.create_time)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.name) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.sourceTypeName(order.url_type)))]), _vm._v(" "), _c('td', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_vm._v(_vm._s(order.url))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_c('button', {
      directives: [{
        name: "clipboard",
        rawName: "v-clipboard:copy",
        value: (order.url),
        expression: "order.url",
        arg: "copy"
      }, {
        name: "clipboard",
        rawName: "v-clipboard:success",
        value: (_vm.copySuccess),
        expression: "copySuccess",
        arg: "success"
      }],
      staticClass: "btn btn-primary",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("複製")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.delcode(order.id, order.target_brand_id, order.target_store_id)
        }
      }
    }, [_vm._v("刪除")])])])])
  }), 0) : _vm._e()])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "float": "right",
      "font-size": "12px",
      "color": "red"
    }
  }, [_vm._v("*項目名稱：最多可輸入10個字 "), _c('br'), _vm._v(" *追蹤碼：限25字內，僅限英數大小寫，不可符號")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info-bg"
  }, [_c('ul', [_c('li', [_vm._v("你訂團隊持續在進行系統優化，如有追蹤訂單來源需求，可自【新後台管理系統】-【成效數據中心】使用[自訂報表]下載報表分析。")]), _vm._v(" "), _c('li', [_vm._v("此追蹤碼功能於近期將不再進行相關維護，如需更進階數據分析需求，可洽你訂同仁詢問GA4數據分析，會有專人與您詳細說明完整方案。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("項目名稱")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("追蹤碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("入口")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("網址")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "12"
    }
  }, [_vm._v("資料讀取中......")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "80px",
      "padding-top": "80px"
    },
    attrs: {
      "rowspan": "1",
      "colspan": "12"
    }
  }, [_c('img', {
    staticClass: "center-block logo",
    staticStyle: {
      "max-width": "148px"
    },
    attrs: {
      "src": "/static/img/noMatchdata.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-bottom": "80px",
      "color": "#696969"
    }
  }, [_vm._v("沒有符合的資料")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-000e3240"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Order/Temp/QueryStringTemp.vue
// module id = 2292
// module chunks = 1